import { asyncRouterMap } from '@/router'

export default {
  namespaced: true,
  state:{
    allRouter:asyncRouterMap,
    Jurisdiction:[],
    roleList:[],//角色列表
    pageSizeArray:[20, 40, 60, 80,100,120,140,240,480],
    exp:{
      /* 小写字母*/
      validateLowerCase:/^[a-z]+$/,
      /* 合法uri*/
      validateURL:/^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/,
      /* 大写字母*/
      validateUpperCase:/^[A-Z]+$/,
      /* 大小写字母*/
      validateAlphabets:/^[A-Za-z]+$/,
      /* email*/
      validateEmail:/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      //数字
      phone:new RegExp(/\s|\D/,'g'),
      //字母数字下划线
      password:new RegExp(/^[a-zA-Z]\w{5,19}$/),
      phoneNum:/^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/,//手机号
      //固话
      phonefixed:/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/,
      //邮政编码
      mailcode:/^[0-9][0-9]{5}$/,
      email:/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,//邮箱
      //用户名
      userName:/^[A-Za-z0-9\u4e00-\u9fa5]+$/,
      //身份正
      idcard:/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
      specialChar:new RegExp("[`~!%@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]"),
    },
    /**职称**/
    docTitles:[],
    /**所有科室**/
    departments:[],
    /**所有医生**/
    doctorList:[],
    /**名医**/
    famousDoctorList:[],
  },
  //异步触发
  actions:{
    getbutton(state,buttonshow){
      let isbutton=false;
      if($vue.$store.state.userinfo.userInfo.role.isRoot=="Y"){
        isbutton=true;
      }else{
        try {
          let router=$vue.$store.state.userinfo.nowRouter.sopauth;
          for(var i=0;i<router.length;i++){
            if(router[i].key==buttonshow){
              isbutton=true;
              break;
            }
          }
        }catch (e) {
          console.error(e)
        }
      }
      return isbutton;
    },
    alertFailAuth(state,str){
      $vue.$notify({
        title: '!提示',
        message: str?str:`权限不足`,
      });
    },// 权限不足
    getRoleList(state){
      $vue.$get(`${$vue.config.interface}role/list`,{}).then(res=>{
          state.commit("getRoleList",res.data)
      })
    },
    //获取医生职称
    getDocTitles({commit,dispatch}){
      return $vue.$get(`${$vue.config.interface}doctor/title`,{})
        .then(res=>{
          console.log(res);
          if(res.code===200){
            commit('setDicTitles', res);
          }
          return res;
        }).catch(res=>{
          return res;
        })
    },
    //获取科室
    getDepartment({commit,dispatch}){
      return $vue.$get(`${$vue.config.interface}doctor/department`,{})
        .then(res=>{
          if(res.code===200){
            commit('setDepartment', res);
          }
          return res;
        }).catch(res=>{
          return res;
        })
    },
    //获取所有审核动过的医师
    getDoctorList({commit,dispatch}){
      return $vue.$get(`${$vue.config.interface1}doctor/doctorList`,{})
        .then(res=>{
          if(res.code===200){
            commit('setDoctorList', res);
          }
          return res;
        }).catch(res=>{
          return res;
        })
    },
    //获取名医列表
    getFamousDoctorList({commit,dispatch}){
      return $vue.$get(`${$vue.config.interface1}user/pageStudio`,{})
        .then(res=>{
          console.log('----名医列表---');
          console.log(res);
          if(res.code===200){
            commit('setFamousDoctorList', res);
          }
          return res;
        }).catch(res=>{
          return res;
        })
    },
  },
//  处理结果或计算
  mutations:{
    setDoctorList(state,res){
      state.doctorList=res.data;
    },
    setFamousDoctorList(state,res){
      let data=res.data;
      data.unshift({doctorId:'',doctorName:'未关联'});
      state.famousDoctorList=data;
    },
    getRoleList(state,roleList){
      state.roleList=roleList;
    },
    //设置职称
    setDicTitles(state,res){
      state.docTitles=res.data;
    },
    //设置科室
    setDepartment(state,res){
      state.departments=res.data;
    },

  },
};



// WEBPACK FOOTER //
// ./src/store/common/common.js